export default "__VITE_ASSET__32lpz4Aq__"